var map = {
	"./arrow-blue.svg": "0hKb",
	"./arrow-bluegrey.svg": "ypyn",
	"./arrow-green.svg": "/Nrg",
	"./arrow-grey.svg": "NfqH",
	"./arrow-orange.svg": "g2dW",
	"./arrow-red.svg": "9HC7",
	"./arrow-white.svg": "Hrx0",
	"./arrow-yellow.svg": "yht5",
	"./blue-circle-arrow.svg": "nDmx",
	"./civ-bus-blue.svg": "exp+",
	"./civ-bus-bluegrey.svg": "PW0o",
	"./civ-bus-green.svg": "47o+",
	"./civ-bus-grey.svg": "py7P",
	"./civ-bus-orange.svg": "Bdz3",
	"./civ-bus-red.svg": "7RRt",
	"./civ-bus-white.svg": "gZMj",
	"./civ-bus-yellow.svg": "dWqg",
	"./coe-4ton-blue.svg": "z6ny",
	"./coe-4ton-bluegrey.svg": "Cuzp",
	"./coe-4ton-green.svg": "zAJt",
	"./coe-4ton-grey.svg": "wbJz",
	"./coe-4ton-orange.svg": "VWpR",
	"./coe-4ton-red.svg": "2d8Q",
	"./coe-4ton-refrigerated-blue.svg": "LPoJ",
	"./coe-4ton-refrigerated-bluegrey.svg": "ZP7R",
	"./coe-4ton-refrigerated-green.svg": "r14N",
	"./coe-4ton-refrigerated-grey.svg": "tyP+",
	"./coe-4ton-refrigerated-orange.svg": "YVIR",
	"./coe-4ton-refrigerated-red.svg": "TrNk",
	"./coe-4ton-refrigerated-white.svg": "fkw1",
	"./coe-4ton-refrigerated-yellow.svg": "+CdO",
	"./coe-4ton-white.svg": "EFRX",
	"./coe-4ton-yellow.svg": "yQ8i",
	"./coe-heavy-horse-blue.svg": "UEYE",
	"./coe-heavy-horse-bluegrey.svg": "bePw",
	"./coe-heavy-horse-green.svg": "oN/I",
	"./coe-heavy-horse-grey.svg": "exoO",
	"./coe-heavy-horse-orange.svg": "luC3",
	"./coe-heavy-horse-red.svg": "lga0",
	"./coe-heavy-horse-white.svg": "vNuy",
	"./coe-heavy-horse-yellow.svg": "0oPL",
	"./coe-heavy-tanker-blue.svg": "UJnN",
	"./coe-heavy-tanker-bluegrey.svg": "v+bu",
	"./coe-heavy-tanker-green.svg": "yqsF",
	"./coe-heavy-tanker-grey.svg": "lOY4",
	"./coe-heavy-tanker-orange.svg": "A6Zb",
	"./coe-heavy-tanker-red.svg": "7S0u",
	"./coe-heavy-tanker-white.svg": "Cia4",
	"./coe-heavy-tanker-yellow.svg": "LfE+",
	"./coe-heavy-trailer-blue.svg": "Xw4t",
	"./coe-heavy-trailer-bluegrey.svg": "2SVp",
	"./coe-heavy-trailer-green.svg": "mHJW",
	"./coe-heavy-trailer-grey.svg": "1PWF",
	"./coe-heavy-trailer-orange.svg": "Lu/E",
	"./coe-heavy-trailer-red.svg": "k+Ip",
	"./coe-heavy-trailer-white.svg": "ETuP",
	"./coe-heavy-trailer-yellow.svg": "di4f",
	"./dot-01-blue.svg": "ppJi",
	"./dot-01-bluegrey.svg": "xjYG",
	"./dot-01-green.svg": "Tt5B",
	"./dot-01-grey.svg": "4dWB",
	"./dot-01-orange.svg": "fwTu",
	"./dot-01-red.svg": "osFX",
	"./dot-01-white.svg": "Nhce",
	"./dot-01-yellow.svg": "zA9M",
	"./hatchback-blue.svg": "uh4U",
	"./hatchback-bluegrey.svg": "k7w/",
	"./hatchback-green.svg": "uh42",
	"./hatchback-grey.svg": "bif6",
	"./hatchback-indigo.svg": "rtaF",
	"./hatchback-orange.svg": "PXPw",
	"./hatchback-red.svg": "v+ba",
	"./hatchback-white.svg": "qmGQ",
	"./hatchback-yellow.svg": "8Er1",
	"./location-dot.svg": "VRIY",
	"./medium-truck-blue.svg": "n84T",
	"./medium-truck-bluegrey.svg": "VOp5",
	"./medium-truck-green.svg": "lK2s",
	"./medium-truck-grey.svg": "1l8L",
	"./medium-truck-orange.svg": "Pcy4",
	"./medium-truck-red.svg": "nvwn",
	"./medium-truck-white.svg": "WD1C",
	"./medium-truck-yellow.svg": "COMT",
	"./mini-bus-blue.svg": "/cI4",
	"./mini-bus-bluegrey.svg": "ZdM5",
	"./mini-bus-green.svg": "dgd6",
	"./mini-bus-grey.svg": "oGwM",
	"./mini-bus-orange.svg": "QFBp",
	"./mini-bus-red.svg": "LeaY",
	"./mini-bus-white.svg": "os3l",
	"./mini-bus-yellow.svg": "thLz",
	"./mining-dump-truck-blue.svg": "Xfox",
	"./mining-dump-truck-bluegrey.svg": "vfV2",
	"./mining-dump-truck-green.svg": "97xp",
	"./mining-dump-truck-grey.svg": "jgiI",
	"./mining-dump-truck-orange.svg": "hFK0",
	"./mining-dump-truck-red.svg": "H7o1",
	"./mining-dump-truck-white.svg": "QQoo",
	"./mining-dump-truck-yellow.svg": "+NgP",
	"./motorbike-blue.svg": "2qha",
	"./motorbike-bluegrey.svg": "Sgk6",
	"./motorbike-green.svg": "gH3H",
	"./motorbike-grey.svg": "cCKB",
	"./motorbike-orange.svg": "RTex",
	"./motorbike-red.svg": "gmQ5",
	"./motorbike-white.svg": "+nyJ",
	"./motorbike-yellow.svg": "1Zlo",
	"./pickup-doublecab-blue.svg": "wfxL",
	"./pickup-doublecab-bluegrey.svg": "r5jJ",
	"./pickup-doublecab-green.svg": "d6Af",
	"./pickup-doublecab-grey.svg": "IOiJ",
	"./pickup-doublecab-orange.svg": "LwCX",
	"./pickup-doublecab-red.svg": "YluA",
	"./pickup-doublecab-white.svg": "0gBk",
	"./pickup-doublecab-yellow.svg": "gnwi",
	"./pickup-singlecab-blue.svg": "1l8Y",
	"./pickup-singlecab-bluegrey.svg": "seKb",
	"./pickup-singlecab-green.svg": "Wt6E",
	"./pickup-singlecab-grey.svg": "su0m",
	"./pickup-singlecab-orange.svg": "A8oW",
	"./pickup-singlecab-red.svg": "nQK1",
	"./pickup-singlecab-white.svg": "tngU",
	"./pickup-singlecab-yellow.svg": "5Nwh",
	"./pin-01-blue.svg": "4jng",
	"./pin-01-bluegrey.svg": "wcfx",
	"./pin-01-green.svg": "3+p/",
	"./pin-01-grey.svg": "rONt",
	"./pin-01-orange.svg": "PetH",
	"./pin-01-red.svg": "9BVt",
	"./pin-01-white.svg": "kAz4",
	"./pin-01-yellow.svg": "XTwO",
	"./rv-blue.svg": "ZX2Y",
	"./rv-bluegrey.svg": "TLRd",
	"./rv-green.svg": "CDF5",
	"./rv-grey.svg": "hrVu",
	"./rv-orange.svg": "g0Hy",
	"./rv-red.svg": "473R",
	"./rv-white.svg": "YeVS",
	"./rv-yellow.svg": "LTOi",
	"./sedan-blue.svg": "Syxk",
	"./sedan-bluegrey.svg": "rz1d",
	"./sedan-green.svg": "gosM",
	"./sedan-grey.svg": "rjFs",
	"./sedan-indigo.svg": "pryf",
	"./sedan-orange.svg": "mVpd",
	"./sedan-red.svg": "DwOa",
	"./sedan-white.svg": "hw3n",
	"./sedan-yellow.svg": "j+TR",
	"./semi-heavy-horse-blue.svg": "U9wb",
	"./semi-heavy-horse-bluegrey.svg": "FAG5",
	"./semi-heavy-horse-green.svg": "/c7Q",
	"./semi-heavy-horse-grey.svg": "cCmC",
	"./semi-heavy-horse-orange.svg": "cG7E",
	"./semi-heavy-horse-red.svg": "XYEL",
	"./semi-heavy-horse-white.svg": "wR6a",
	"./semi-heavy-horse-yellow.svg": "NAUZ",
	"./semi-heavy-tanker-blue.svg": "28jT",
	"./semi-heavy-tanker-bluegrey.svg": "16IO",
	"./semi-heavy-tanker-green.svg": "cTYv",
	"./semi-heavy-tanker-grey.svg": "095u",
	"./semi-heavy-tanker-orange.svg": "6F7u",
	"./semi-heavy-tanker-red.svg": "PRSu",
	"./semi-heavy-tanker-white.svg": "WWK1",
	"./semi-heavy-tanker-yellow.svg": "lOaR",
	"./semi-heavy-trailer-blue.svg": "45ns",
	"./semi-heavy-trailer-bluegrey.svg": "LlY4",
	"./semi-heavy-trailer-green.svg": "K2i/",
	"./semi-heavy-trailer-grey.svg": "YSTH",
	"./semi-heavy-trailer-orange.svg": "dtPX",
	"./semi-heavy-trailer-red.svg": "yPqH",
	"./semi-heavy-trailer-white.svg": "f4r4",
	"./semi-heavy-trailer-yellow.svg": "l0+X",
	"./suv-blue.svg": "j8QR",
	"./suv-bluegrey.svg": "sBDj",
	"./suv-green.svg": "JcV7",
	"./suv-grey.svg": "9rvZ",
	"./suv-orange.svg": "WPa4",
	"./suv-red.svg": "PbPk",
	"./suv-white.svg": "K3Ym",
	"./suv-yellow.svg": "ueje",
	"./target-orange.svg": "KGqm",
	"./target-red.svg": "zGud",
	"./target-yellow.svg": "GbeN",
	"./walking-man-blue.svg": "OMBx",
	"./walking-man-bluegrey.svg": "KHlh",
	"./walking-man-green.svg": "mRpg",
	"./walking-man-grey.svg": "UwM/",
	"./walking-man-orange.svg": "Iql2",
	"./walking-man-red.svg": "G0VA",
	"./walking-man-white.svg": "UUXo",
	"./walking-man-yellow.svg": "3YJz"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "gCqJ";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg ^\.\/.*$
// module id = gCqJ
// module chunks = 82